export class ContentModelPopupDetails {
  firstButtonText: string;
  modelDescription: string;
  modelTitle: string;
  secondButtonText: string;
  submitUrl: string;

  constructor(contentjson?: any) {
    if (contentjson) {
      if (contentjson['firstButtonText']) {
        this.firstButtonText = contentjson['firstButtonText'];
      }
      if (contentjson['modelDescription']) {
        this.modelDescription = contentjson['modelDescription'];
      }
      if (contentjson['modelTitle']) {
        this.modelTitle = contentjson['modelTitle'];
      }
      if (contentjson['secondButtonText']) {
        this.secondButtonText = contentjson['secondButtonText'];
      }
      if (contentjson['submitUrl']) {
        this.submitUrl = contentjson['submitUrl'];
      }
    }
  }
}
